// Renders one label and value row in the details panel.

import { TruncatedText } from '@/components/shared/truncated-text';

/** What the panel prints where a field has no value; there is nothing to copy. */
const EMPTY = '\u2014';

export function FieldRow({ label, value }: { label: string; value: string }) {
  return (
    // The value keeps to the right edge as the panel widens, as MetaRow already does —
    // two flex-1 columns left it stranded mid-row with the gap growing beside it.
    <div className="flex w-full items-start justify-between gap-5">
      <p className="shrink-0 text-[12px] font-medium leading-[1.1] text-gray-700">{label}</p>
      <TruncatedText
        text={value}
        copyable={value.trim() !== '' && value.trim() !== EMPTY}
        className="min-w-0 text-right text-[12px] leading-[1.1] text-text-body"
      />
    </div>
  );
}
